export const composeLocation = (
  state: string,
  district: string,
  mandal: string,
  village: string,
): string => [state, district, mandal, village].filter(Boolean).join(', ');

export const parseLocation = (
  location?: string,
): { state: string; district: string; mandal: string; village: string } => {
  if (!location) return { state: '', district: '', mandal: '', village: '' };
  const parts = location.split(',').map((value) => value.trim());
  if (parts.length >= 4) {
    return {
      state: parts[0] || '',
      district: parts[1] || '',
      mandal: parts[2] || '',
      village: parts[3] || '',
    };
  }
  return {
    state: 'Telangana',
    district: parts[0] || '',
    mandal: parts[1] || '',
    village: parts[2] || '',
  };
};
